import React from 'react';
import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const AirFilterWidget = ({
  borderColor,
  backgroundColor,
  width = 22,
  height = 58,
  ...rest
}: {
  dotsColor?: string;
  borderColor?: string;
  backgroundColor?: string;
  width?: number;
  height?: number;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentBorderColor = borderColor ?? token.colorBorder;
  const currentBackgroundColor = backgroundColor ?? token.colorBgContainer;

  return (
    <svg width={width} height={height} viewBox="0 0 22 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect
        x="4"
        y="2.5"
        width="14"
        height="55"
        rx="1"
        fill={currentBackgroundColor}
        stroke={currentBorderColor}
        strokeWidth="2"
      />
      <rect x="1" y="0.5" width="20" height="9" rx="2" fill={currentBorderColor} />
      <path
        d="M18 26.5H20C21.1046 26.5 22 27.3954 22 28.5V36.5C22 37.6046 21.1046 38.5 20 38.5H18V26.5Z"
        fill={token.colorBorder}
      />
      <path
        d="M4 38.5H2C0.895431 38.5 0 37.6046 0 36.5L0 28.5C0 27.3954 0.895431 26.5 2 26.5H4L4 38.5Z"
        fill={token.colorBorder}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 14.5C9.32843 14.5 10 13.8284 10 13C10 12.1716 9.32843 11.5 8.5 11.5C7.67157 11.5 7 12.1716 7 13C7 13.8284 7.67157 14.5 8.5 14.5ZM8.5 24.5C9.32843 24.5 10 23.8284 10 23C10 22.1716 9.32843 21.5 8.5 21.5C7.67157 21.5 7 22.1716 7 23C7 23.8284 7.67157 24.5 8.5 24.5ZM15 13C15 13.8284 14.3284 14.5 13.5 14.5C12.6716 14.5 12 13.8284 12 13C12 12.1716 12.6716 11.5 13.5 11.5C14.3284 11.5 15 12.1716 15 13ZM13.5 24.5C14.3284 24.5 15 23.8284 15 23C15 22.1716 14.3284 21.5 13.5 21.5C12.6716 21.5 12 22.1716 12 23C12 23.8284 12.6716 24.5 13.5 24.5ZM10 33C10 33.8284 9.32843 34.5 8.5 34.5C7.67157 34.5 7 33.8284 7 33C7 32.1716 7.67157 31.5 8.5 31.5C9.32843 31.5 10 32.1716 10 33ZM13.5 34.5C14.3284 34.5 15 33.8284 15 33C15 32.1716 14.3284 31.5 13.5 31.5C12.6716 31.5 12 32.1716 12 33C12 33.8284 12.6716 34.5 13.5 34.5ZM10 43C10 43.8284 9.32843 44.5 8.5 44.5C7.67157 44.5 7 43.8284 7 43C7 42.1716 7.67157 41.5 8.5 41.5C9.32843 41.5 10 42.1716 10 43ZM13.5 44.5C14.3284 44.5 15 43.8284 15 43C15 42.1716 14.3284 41.5 13.5 41.5C12.6716 41.5 12 42.1716 12 43C12 43.8284 12.6716 44.5 13.5 44.5ZM10 53C10 53.8284 9.32843 54.5 8.5 54.5C7.67157 54.5 7 53.8284 7 53C7 52.1716 7.67157 51.5 8.5 51.5C9.32843 51.5 10 52.1716 10 53ZM13.5 54.5C14.3284 54.5 15 53.8284 15 53C15 52.1716 14.3284 51.5 13.5 51.5C12.6716 51.5 12 52.1716 12 53C12 53.8284 12.6716 54.5 13.5 54.5ZM12.5 18C12.5 18.8284 11.8284 19.5 11 19.5C10.1716 19.5 9.5 18.8284 9.5 18C9.5 17.1716 10.1716 16.5 11 16.5C11.8284 16.5 12.5 17.1716 12.5 18ZM11 29.5C11.8284 29.5 12.5 28.8284 12.5 28C12.5 27.1716 11.8284 26.5 11 26.5C10.1716 26.5 9.5 27.1716 9.5 28C9.5 28.8284 10.1716 29.5 11 29.5ZM12.5 38C12.5 38.8284 11.8284 39.5 11 39.5C10.1716 39.5 9.5 38.8284 9.5 38C9.5 37.1716 10.1716 36.5 11 36.5C11.8284 36.5 12.5 37.1716 12.5 38ZM11 49.5C11.8284 49.5 12.5 48.8284 12.5 48C12.5 47.1716 11.8284 46.5 11 46.5C10.1716 46.5 9.5 47.1716 9.5 48C9.5 48.8284 10.1716 49.5 11 49.5Z"
        fill={token.colorPrimary}
      />
    </svg>
  );
};

export default AirFilterWidget;
